<template>
  <div class="page-box">
    <el-form
      :model="form"
      ref="form"
      :rules="rules"
      label-width="auto"
      :inline="false"
    >
      <el-form-item label="组别分类名称:" prop="classifyName">
        <el-input v-model="form.classifyName"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { get } from "lodash";
import { saveGroupClassify } from "../../../../../api/mymatchs/groupsetitem";
export default {
  name: "add-group-type",
  data() {
    return {
      form: {
        classifyName: "",
        matchId:'',
      },
      rules: {
        classifyName: [{ required: true, message: "请输入组别分类名称", trigger: "blur" }],
      },
    };
  },
  created() {
    const {matchId,id} = this.$attrs.params;
    console.log(matchId,id)
    if(matchId) {
      this.form.matchId = matchId
      if(id){
        this.$set(this.form,'id',id);
        this.$set(this.form,'classifyName',this.$attrs.params.classifyName)
      }
    }
  },
  methods: {
    confirm(callback,close) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await saveGroupClassify(this.form);
          if(res && res.status == 200){
            callback();
            close();
          }
        } else {
          return false;
        }
      });

    },
  },
};
</script>
<style lang="scss" scoped>
.page-box {
  padding: 15px;
}
</style>
